import React, { useEffect, useRef, useState } from 'react';
import { Box, CardContent, Grid } from '@mui/material';
import ContainerCard from 'components/Containers/Card/ContainerCard';
import HeaderCard from 'components/Containers/Card/HeaderCard';
import GroupButton from 'components/Buttons/ButtonGroup';
import { useDependencyInjection } from 'hooks/useDependencyInjection';
import SalesData from './components/SalesData';
import { generateNumber, isValidDate } from 'utils';
import Apportionment from 'components/Apportionment';
import Bill from 'components/Bill';

function Sale() {
  const {
    location: { state },
    classes, id, disable, loadingRequest, success, error, history, requestCompleted, api,
  } = useDependencyInjection();

  const dataLocation = state?.data || state?.customData;

  const prevRoute = state?.prevRoute?.path;

  const salesDataComponentRef = useRef(null);
  const billComponentRef = useRef(null);
  const apportionmentComponentRef = useRef(null);

  const salesDataRef = useRef(null);
  const billRef = useRef(null);
  const apportionmentRef = useRef(null);

  const [loading, setLoading] = useState(true);
  const [totalPrice, setTotalPrice] = useState(0);
  const [billValue, setBillValue] = useState();

  const callbackFunctionSalesData = (payload) => {
    salesDataRef.current = payload;
  };

  const callbackFunctionBill = (payload) => {
    billRef.current = payload;
  };

  const callbackFunctionApportionment = (payload) => {
    apportionmentRef.current = payload;
  };

  const getBillValue = (value) => {
    setBillValue(value);
  };

  const formsValid = () => salesDataRef.current.isValid && billRef.current.isValid && apportionmentRef.current.isValid;

  const getValues = (ref) => ref.current?.values;

  const isPendentSale = dataLocation?.status === 'pendente';

  const info = {
    description: 'Venda de Produção',
    type: 'recebimento',
  };

  async function request(data) {
    try {
      loadingRequest();
      if (id) {
        await api.put(`/sales/${id}`, data);
      } else {
        await api.post('/sales/harvest', data);
      }
      success();
      const path = prevRoute || '/sales';
      history.push(path);
    } catch (err) {
      error();
    } finally {
      requestCompleted();
    }
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  const handleUpdateTotalPrice = (value) => {
    setTotalPrice(value);
  };

  // dispara submits dos componentes filhos
  const handleSubmitForms = () => {
    salesDataComponentRef.current.handleSubmit();
    billComponentRef.current.handleSubmit();
    apportionmentComponentRef.current.handleSubmit();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleSubmitForms();

    if (formsValid()) {
      const payload = {
        ...getValues(salesDataRef),
        status: id ? dataLocation.status : getValues(salesDataRef).status,
        date: id ? isValidDate(dataLocation.date) : new Date(),
        bill: {
          ...getValues(billRef),
          ...getValues(apportionmentRef),
          id: id ? dataLocation?.bill?.id : null,
          type: info.type,
          description: info.description,
          number: generateNumber(getValues(salesDataRef).stakeholder.id),
          stakeholder: getValues(salesDataRef).stakeholder,
        },
      };

      request(payload);
    }
  };

  return (
    <ContainerCard loading={id && loading}>
      <form onSubmit={handleSubmit}>
        <Box className={classes.root}>
          <HeaderCard
            title={id ? 'Venda' : 'Nova Venda'}
          />
          <CardContent sx={{
            '&.MuiCardContent-root': {
              padding: 0,
            },
          }}
          >
            <Grid container direction="column" gap={3}>
              <Grid item>
                <SalesData
                  ref={salesDataComponentRef}
                  callback={callbackFunctionSalesData}
                  updateTotalPrice={handleUpdateTotalPrice}
                />
              </Grid>
              {!isPendentSale && (
                <Grid item>
                  <Bill
                    getBillValue={getBillValue}
                    ref={billComponentRef}
                    type="recebimento"
                    description="Venda de Produção"
                    disabledStakeholder
                    totalPrice={totalPrice}
                    disabledTotalValue
                    callback={callbackFunctionBill}
                  />
                </Grid>
              )}
              <Grid item>
                <Apportionment
                  billValue={billValue}
                  callback={callbackFunctionApportionment}
                  ref={apportionmentComponentRef}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Box>
        <GroupButton
          deleteRoute="/sales/"
          routeDelete="/sales/"
          returnRoute="/sales/"
          id={id}
          disable={disable}
          messageDialogError
          disableTemporary={false} // Desativar o botão de delete
          message="Deseja realmente excluir essa venda?"
        />
      </form>
    </ContainerCard>
  );
}

export default Sale;
